import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import styles from "./StreamTitle.css";
import { a11yOnly } from "styles/global.css";
import { HeaderContext } from "config/contexts";

export default function StreamTitle(props) {
  return (
    <HeaderContext.Consumer>
      {headerLevels => {
        const HeadingTag = "h" + headerLevels.streamHeader;
        return (
          <HeadingTag
            className={classNames(styles.root, { [a11yOnly]: props.a11yOnly })}
          >
            {props.text}
            {props.unreadCount > 0 && " / "}
            {props.unreadCount > 0 &&
              `${
                props.unreadCount > 20 ? "20+" : props.unreadCount
              } Unread Stor${props.unreadCount === 1 ? "y" : "ies"}`}
          </HeadingTag>
        );
      }}
    </HeaderContext.Consumer>
  );
}

StreamTitle.propTypes = {
  text: PropTypes.string.isRequired,
  unreadCount: PropTypes.number,
  a11yOnly: PropTypes.bool,
};
